import React from "react";
import styles from "./ScoreboardSkeleton.module.scss";

const ScoreboardSkeleton: React.FC = () => {
  return (
    <div className={styles.scoreboardContainer}>
      <div className={styles.scoreboardCard}>
        <div className={styles.skeletonHeader}></div>

        <div className={styles.skeletonTable}>
          {[...Array(10)].map((_, index) => (
            <div key={index} className={styles.skeletonRow}>
              <div className={styles.skeletonCell}></div>
              <div className={styles.skeletonCell}></div>
              <div className={styles.skeletonCell}></div>
              <div className={styles.skeletonCell}></div>
            </div>
          ))}
        </div>

        <div className={styles.skeletonButton}></div>
      </div>
    </div>
  );
};

export default ScoreboardSkeleton;
